import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/attendances/_layout/')({
  beforeLoad: () => {
    throw redirect({
      to: '/attendances/overview'
    });
  }
});